import React from 'react';

// Provides info about authenticated/ logged in user to manage state/ share across compoenents

const UserContext = React.createContext();

export default UserContext;